// extracted by mini-css-extract-plugin
module.exports = {"btn-actions":"issue-participant-form_btn-actions__2ObVT","add-btn":"issue-participant-form_add-btn__1r1FE","content-buffer":"issue-participant-form_content-buffer__2inmf"};